<template>
  <div id="main-dashboard" class="user-dashboard">
    <DashboardSidebar
      v-bind:sidebarMenus="getSidebarMenu()"
      v-on:toBeDisplayed="toBeDisplayed"
      v-on:toggleSidebar="toggleSidebar"
      :touchSidebarButton="touchSidebarButton"
      v-bind:userType="getUserData.userType"
    />
    <div class="context">
      <DashboardHeader
        v-bind:menuItem="menuItem"
        v-bind:profileUrl="getUserData.profileUrl"
        v-bind:userName="getUserData.firstName"
        v-bind:userType="userType"
        v-on:toggleSidebar="toggleSidebar"
      />

      <div class="right-slide dashboard-main" v-switch="display">
        <div v-case="'Dashboard'">
          <AdminDashboard
            v-if="
              !loading &&
              display==='Dashboard' &&
              getUserData.userType &&
              getUserData.userType === 'admin'
            "
            v-bind:userData="getUserData"
            v-on:backToPostJob="backToPostJob"
            v-on:backToApplications="backToApplications"
            v-on:backToJobs="backToJobs"
            v-on:creatorJobView="toJobDetail"
            v-on:viewApplication="viewApplication"
          />

          <BusinessDashboard
            v-if="
              !loading &&
              display==='Dashboard' &&
              getUserData.userType &&
              getUserData.userType === 'business'
            "
            v-bind:userData="getUserData"
            v-on:backToPostJob="backToPostJob"
            v-on:backToApplications="backToApplications"
            v-on:backToJobs="backToJobs"
            v-on:creatorJobView="toJobDetail"
            v-on:viewApplication="viewApplication"
          />

          <ApplicantDashboard
            v-if="
              display==='Dashboard' &&
              !loading &&
              getUserData.userType &&
              getUserData.userType === 'normal-user'
            "
            v-bind:userData="getUserData"
            v-on:backToApplications="backToApplications"
            v-on:backToJobs="backToJobs"
            v-on:applicantJobView="setJobId"
          />

          <AgencyDashboard
            v-if="
              display==='Dashboard' &&
              !loading &&
              !getUserData.userType
            "
            v-bind:userData="getUserData"
            v-on:backToPostJob="backToPostJob"
            v-on:backToApplications="backToApplications"
            v-on:backToJobs="backToJobs"
            v-on:creatorJobView="toJobDetail"
            v-on:viewApplication="viewApplication"
          />
        </div>

        <div v-case="'Jobs'">
          <ApplicantJobList
            v-if="
              !loading &&
              display==='Jobs' &&
              getUserData.userType &&
              getUserData.userType === 'normal-user'
            "
            v-on:setJobId="setJobId"
          />
          <AdminJobsList
            v-if="
              !loading &&
              display==='Jobs' &&
              getUserData.userType &&
              getUserData.userType === 'admin'
            "
            v-on:editJob="editJob"
            v-on:jobDetail="toJobDetail"
            v-on:backToPostJob="backToPostJob"
            :jobCreatorId="getUserData.id"
          />
          <AgencyJobsList
            v-if="
              !loading &&
              display==='Jobs' &&
              !getUserData.userType
            "
            v-on:editJob="editJob"
            v-on:jobDetail="toJobDetail"
            v-on:backToPostJob="backToPostJob"
            :jobCreatorId="getUserData.id"
          />
          <BusinessJobsList
            v-if="
              display==='Jobs' &&
              !loading &&
              getUserData.userType &&
              getUserData.userType === 'business'
            "
            v-on:editJob="editJob"
            v-on:backToPostJob="backToPostJob"
            v-on:jobDetail="toJobDetail"
            :jobCreatorId="getUserData.id"
          />
        </div>

        <div v-case="'Post Job'">
          <CreateJob
            v-if="
              !loading &&
              display==='Post Job' &&
              getUserData.userType !== 'normal-user'"
            :jobCreatorId="getUserData.id"
            v-on:backToJobs="backToJobs"
            v-on:backToPostJob="backToPostJob"
          />
        </div>

        <div v-case="'Edit Job'" v-if="this.$route.params.jobId">
          <EditJob
            v-if="!loading &&
              display==='Edit Job' &&
              getUserData.userType !== 'normal-user'"
            :jobCreatorId="getUserData.id"
            v-on:backToJobs="backToJobs"
            v-on:backToPostJob="backToPostJob"
          />
        </div>

        <div v-case="'Job Detail'" v-if="this.$route.params.jobID">
          <JobDetail
            v-if="!loading &&
              display==='Job Detail' &&
            getUserData.userType !== 'normal-user'"
            v-on:backToJobs="backToJobs"
            v-on:backToPostJob="backToPostJob"
            v-on:editJob="editJob"
            v-on:viewApplication="viewApplication"
            :jobId='jobId'
          />
        </div>

        <div v-case="'Applicant Job Detail'" v-if="this.$route.params.id">
          <ApplicantJobDetail
            v-if="!loading &&
            display==='Applicant Job Detail' &&
             getUserData.userType === 'normal-user'"
            :jobId='jobId'
            v-on:backToJobs="backToJobs"
          />
        </div>

        <div v-case="'Businesses'" v-if="getUserData.userType === 'admin'">
          <AdminBusinessesList
            v-if="
              display==='Businesses' &&
              !loading"
            v-on:backToJobs="backToJobs"
            v-on:backToPostJob="backToPostJob"
            :jobCreatorId="getUserData.id"
          />
        </div>

        <div v-case="'Candidates'" v-if="getUserData.userType === 'admin'">
          <AdminJobApplicantsList
            v-if="
              display==='Candidates' &&
              !loading"
            :jobCreatorId="getUserData.id"
            v-on:backToJobs="backToJobs"
            v-on:backToPostJob="backToPostJob"
          />
        </div>

        <div v-case="'Agencies'" v-if="getUserData.userType === 'admin'">
          <AdminAgenciesList
            v-if="!loading &&
              display==='Agencies'
            "
            v-on:backToJobs="backToJobs"
            v-on:backToPostJob="backToPostJob"
            :jobCreatorId="getUserData.id"
          />
        </div>

        <div v-case="'Applications'">
          <AdminApplicationsList
            v-if="
              !loading &&
              display==='Applications' &&
              getUserData.userType &&
              getUserData.userType === 'admin'"
              v-on:redirectToJobs="backToPostJob"
              v-on:viewApplication="viewApplication"
          />

          <ApplicantApplicationsList
            v-if="
              !loading &&
              display==='Applications' &&
              getUserData.userType &&
              getUserData.userType === 'normal-user'
            "
            v-on:redirectToJobs="backToJobs"
            v-on:setJobId="setJobId"
          />

          <BusinessApplicationsList
            v-if="
              !loading &&
              display==='Applications' &&
              getUserData.userType &&
              getUserData.userType === 'business'"
              v-on:redirectToJobs="backToPostJob"
              v-on:viewApplication="viewApplication"
          />

          <AgencyApplicationsList
            v-if="
              display==='Applications' &&
              !loading && !getUserData.userType"
              v-on:redirectToJobs="backToPostJob"
              v-on:viewApplication="viewApplication"
          />
        </div>

        <div v-case="'Application'" v-if="this.$route.params.applicationId">
          <ApplicationReview
            v-if="
              !loading &&
              display==='Application' &&
              getUserData.userType !== 'normal-user'
              "
            :applicationId = "applicationId"
            v-on:backToPostJob="backToPostJob"
            v-on:backToApplications="backToApplications"
            v-on:viewApplication="viewApplication"
          />
        </div>

        <div v-case="'Settings'">
          <ProfileSettings
            v-if="!loading &&
              display==='Settings' &&
              getUserData.userType !== 'normal-user'"
            v-on:logout="logout()"

          />

          <ApplicantProfileSettings
            v-if="!loading &&
              display==='Settings' &&
              getUserData.userType === 'normal-user'"
            v-on:logout="logout()"
          />
        </div>

      </div>
      <!-- End of Right-slide Dasboard-Main -->

    </div>
    <!-- End of Context Div -->
  </div>
</template>
<script>
import Vue from 'vue';
import VSwitch from 'v-switch-case';
Vue.use(VSwitch);

import DashboardHeader from '../components/DashboardHeader.vue';
import DashboardSidebar from '../components/body/DashboardSidebar.vue';
import AdminDashboard from './admin/AdminDashboard.vue';
import ApplicantDashboard from './applicant/ApplicantDashboard.vue';
import ApplicantJobList from './applicant/ApplicantJobList.vue';
import JobDetail from '../components/JobDetail/JobDetail.vue';
import ApplicantJobDetail from './applicant/ApplicantJobDetail.vue';
import CreateJob from '../components/Job/CreateJob.vue';
import EditJob from '../components/Job/EditJob.vue';
import AdminBusinessesList from './admin/AdminBusinessesList.vue';
import AdminJobApplicantsList from './admin/AdminJobApplicantsList.vue';
import AdminAgenciesList from './admin/AdminAgenciesList.vue';
import AdminApplicationsList from './admin/AdminApplicationsList.vue';
import ApplicantApplicationsList from './applicant/ApplicantApplicationsList.vue';
import BusinessApplicationsList from './business/BusinessApplicationsList.vue';
import AgencyApplicationsList from './agency/AgencyApplicationsList.vue';
import ApplicationReview from './ApplicationReview.vue';
import BusinessDashboard from './business/BusinessDashboard.vue';
import ProfileSettings from './ProfileSettings.vue';
import ApplicantProfileSettings from './applicant/ApplicantProfileSettings.vue';
import AgencyDashboard from './agency/AgencyDashboard.vue';
import AdminJobsList from './admin/AdminJobsList.vue';
import AgencyJobsList from './agency/AgencyJobsList.vue';
import BusinessJobsList from './business/BusinessJobsList.vue';

//Sidebar Icons
import darkDashboardIcon from '../assets/images/dashboard-logo-dark.png';
import dashboardIcon from '../assets/images/dashboard-logo.svg';
import jobsIcon from '../assets/images/job-logo.png';
import darkJobsIcon from '../assets/images/jobs-dark.png';
import applicationsIcon from '../assets/images/applications-logo.png';
import darkApplicationsIcon from '../assets/images/application-dark.svg';
import settingsIcon from '../assets/images/settings-logo.png';
import darkSettingsIcon from '../assets/images/settings-dark.png';
import logoutIcon from '../assets/images/log-out-logo.png';
import businessesIcon from '../assets/images/businesses.png';
import businessesIconDark from '../assets/images/businesses-dark.png';
import jobSeekersIcon from '../assets/images/jobseekers-logo.png';
import jobSeekersIconDark from '../assets/images/jobseekers-dark-logo.png';

export default {
  name: 'MainDashboard',
  // props: ["userData"],
  components: {
    DashboardHeader,
    DashboardSidebar,
    AdminDashboard,
    ApplicantDashboard,
    ApplicantJobList,
    JobDetail,
    ApplicantJobDetail,
    CreateJob,
    EditJob,
    AdminBusinessesList,
    AdminJobApplicantsList,
    AdminAgenciesList,
    AdminApplicationsList,
    ApplicantApplicationsList,
    BusinessApplicationsList,
    AgencyApplicationsList,
    ApplicationReview,
    BusinessDashboard,
    ProfileSettings,
    ApplicantProfileSettings,
    AgencyDashboard,
    AdminJobsList,
    AgencyJobsList,
    BusinessJobsList,
  },
  data() {
    return {
      menuItem: 'Dashboard',
      loading: false,
      userType: '',
      userLocation: '',
      display: 'Jobs',
      touchSidebarButton: false,
      showJobDetail: false,
      showCreateJobComponent: false,
      applicationId: null,
      jobId: null,
      sidebarMenus: [
        {
          title: 'Dashboard',
          link: '/dashboard',
          icon: dashboardIcon,
          darkIcon: darkDashboardIcon,
        },
        {
          title: 'Jobs',
          link: '/jobs',
          icon: jobsIcon,
          darkIcon: darkJobsIcon,
        },
        {
          title: 'Applications',
          link: '/applications',
          icon: applicationsIcon,
          darkIcon: darkApplicationsIcon,
        },
        {
          title: 'Settings',
          link: '/settings',
          icon: settingsIcon,
          darkIcon: darkSettingsIcon,
        },
        { title: 'Log-out', link: '/logout', icon: logoutIcon },
      ],

      adminSidebarMenus: [
        {
          title: 'Dashboard',
          link: '/dashboard',
          icon: dashboardIcon,
          darkIcon: darkDashboardIcon,
        },
        {
          title: 'Jobs',
          link: '/jobs',
          icon: jobsIcon,
          darkIcon: darkJobsIcon,
        },
        {
          title: 'Applications',
          link: '/applications',
          icon: applicationsIcon,
          darkIcon: darkApplicationsIcon,
        },
        {
          title: 'Agencies',
          link: '/agencies',
          icon: businessesIcon,
          darkIcon: businessesIconDark,
        },
        {
          title: 'Businesses',
          link: '/businesses',
          icon: businessesIcon,
          darkIcon: businessesIconDark,
        },
        {
          title: 'Candidates',
          link: '/candidates',
          icon: jobSeekersIcon,
          darkIcon: jobSeekersIconDark,
        },
        {
          title: 'Settings',
          link: '/settings',
          icon: settingsIcon,
          darkIcon: darkSettingsIcon,
        },
        { title: 'Log-out', link: '/logout', icon: logoutIcon },
      ],
    };
  },
  methods: {
    backToJobs() {
      this.toBeDisplayed('Jobs');
      if (this.touchSidebarButton) {
        this.lockChild();
      } else {
        this.permitChild();
      }
    },
    backToPostJob () {
      this.toBeDisplayed('Post Job');
      if (this.touchSidebarButton) {
        this.lockChild();
      } else {
        this.permitChild();
      }
    },
    backToApplications () {
      this.toBeDisplayed('Applications');
      if (this.touchSidebarButton) {
        this.lockChild();
      } else {
        this.permitChild();
      }
    },
    viewApplication (id) {
      this.applicationId = id;
      this.toBeDisplayed('Application');
      if (this.touchSidebarButton) {
        this.lockChild();
      } else {
        this.permitChild();
      }
    },
    getSidebarMenu() {
      return this.getUserData.userType !== 'admin'
        ? this.sidebarMenus
        : this.adminSidebarMenus;
    },
    setJobId(jobId) {
      this.jobId = jobId;
      this.toBeDisplayed('Applicant Job Detail');
      if (this.touchSidebarButton) {
        this.lockChild();
      } else {
        this.permitChild();
      }
    },
    toJobDetail(jobId) {
      this.jobId = jobId;
      this.toBeDisplayed('Job Detail');
      if (this.touchSidebarButton) {
        this.lockChild();
      } else {
        this.permitChild();
      }
    },
    editJob(id) {
      this.jobId = id;
      this.toBeDisplayed('Edit Job');
      if (this.touchSidebarButton) {
        this.lockChild();
      } else {
        this.permitChild();
      }
    },
    toBeDisplayed(changeView) {
      this.display = changeView;
      this.menuItem = changeView;

      // Decide router path and change view;
      switch (changeView) {
        case 'Dashboard':
          this.$router.history.current.name === 'Dashboard'
            ? null
            : this.$router.push('/user/dashboard');
          break;

        case 'Jobs':
          this.$router.history.current.name === 'Jobs'
            ? null
            : this.$router.push('/user/jobs');
          break;

        case 'Post Job':
          this.showCreateJobComponent = !this.showCreateJobComponent;
          this.$router.history.current.name === 'Post Job'
            ? null
            : this.$router.push('/user/jobs/create');
          break;

        case 'Job Detail':
          this.$router.history.current.name === 'Job Detail'
            ? null
            : this.$router.push(`/user/jobs/${this.jobId}/detail`);
          break;

        case 'Businesses':
          this.$router.history.current.name === 'Businesses'
            ? null
            : this.$router.push('/user/businesses');
          break;

        case 'Candidates':
          this.$router.history.current.name === 'Candidates'
            ? null
            : this.$router.push('/user/candidates');
          break;

        case 'Agencies':
          this.$router.history.current.name === 'Agencies'
            ? null
            : this.$router.push('/user/agencies');
          break;

        case 'Applications':
          this.$router.history.current.name === 'Applications'
            ? null
            : this.$router.push('/user/applications');
          break;

        case 'Application':
            this.$router.history.current.name === 'Application'
              ? null
              : this.$router.push(`/user/applications/${this.applicationId}/review`);
          break;

        case 'Settings':
          this.$router.history.current.name === 'Settings'
            ? null
            : this.$router.push('/user/settings');
          break;

        case 'Applicant Job Detail':
          this.$router.history.current.name === 'Applicant Job Detail'
            ? null
            : this.$router.push(`/user/jobs/${this.jobId}/apply`);
          break;

        case 'Edit Job':
          this.$router.history.current.name === 'Edit Job'
            ? null
            : this.$router.push(`/user/jobs/${this.jobId}/edit`);
          break;

        case 'Log-out':
          this.logout();
          break;
      }
    },
    toggleSidebar() {
      if (window.innerWidth <= 767) {
        let sidebarMenu = document.querySelector('.side-bar');
        sidebarMenu.classList.toggle('active');
      }
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      localStorage.removeItem('isAuthenticated');
      this.$store.commit('toggleLogin', false);
      this.$router.push('/login');
      this.$toastr.success('Logout Successful', 'Success');
    },
    permitChild: function () {
      this.touchSidebarButton = true;
    },
    lockChild: function () {
      this.touchSidebarButton = false;
    },
  },
  computed: {
    getUserData() {
      return this.$store.state.userData;
    },
  },
  async beforeMount() {
    this.loading = true;
    await this.$store.dispatch('fetchUserData');
    this.loading = false;

    if (this.$store.state.error) {
      this.$router.push('/login');
    }

    if (this.getUserData && this.getUserData.userType === 'admin') {
      this.userType = 'Admin';
    } else if (this.getUserData && this.getUserData.userType === 'business') {
      this.userType = 'Company';
    } else if (
      this.getUserData &&
      this.getUserData.userType === 'normal-user'
    ) {
      this.userType = 'Job Seeker';
    } else {
      this.userType = 'Agency';
    }
  },
  async mounted() {
    if (localStorage.getItem('token')) {
      this.isAuthenticated = true;
    } else {
      this.isAuthenticated = false;
    }
    this.permitChild();
  },
  updated() {
    if (localStorage.getItem('token')) {
      this.isAuthenticated = true;
    } else {
      this.isAuthenticated = false;
    }
  },
};
</script>

<style scoped>
.context {
  width: 82%;
  margin-left: 18%;
}

.dashboard-main {
  padding: 2.5rem;
  margin-top: 6.25rem;
}

.user-dashboard {
  min-height: 100vh;
  /* background: #efefef; */
  background: #e5e5e5;
  display: flex;
  flex-direction: row;
}

@media only screen and (max-width: 767px) {
  .context {
    width: 100%;
    margin-left: 0;
  }
}

@media only screen and (max-width: 565px) {
}
@media only screen and (max-width: 420px) {
}
</style>
